import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { SSO_AUTH_ERROR } from '../../../../constants/common';

const useStyles = makeStyles({
  root:{
    padding: '15px 0',
    textAlign: 'center'
  }
});

const Unauthorized = (props) => {
  const classes = useStyles(props);
  let errorMsg = "You are not authorized to access this page.";
  if (SSO_AUTH_ERROR.hasOwnProperty(props.errorCode)) {
    errorMsg = SSO_AUTH_ERROR[`${props.errorCode}`];
  }

  return(
    <Typography align="center" classes={{root: classes.root}}>{errorMsg}</Typography>
  );
};

export default Unauthorized;
